<template>
  <div id="croppa">
    <croppa v-model="myCroppa" placeholder="" placeholder-color="#000" :width="this.$props.myWidth" :height="this.$props.myHeight" :disabled="this.$props.disabled" :image-border-radius="10" :show-remove-button="this.$props.removeButton" remove-button-color="black" :remove-button-size="0" :show-loading="true" :loading-size="0" :prevent-white-space="true" :zoom-speed="50" :reverse-scroll-to-zoom="false" :quality="this.qualityVal" :disable-drag-to-move="!showIcon" :disable-scroll-to-zoom="!showIcon" :initial-image="this.$props.initImg" accept=".jpg,.jpeg,.png" @file-choose="handleCroppaFileChoose" @image-remove="handleImageRemove">
      <img width='20px' height='20px' slot="placeholder" :src="initSrc">
    </croppa>
    <i :class="closeShow" v-if="showClose" @click="close" class="el-icon-circle-close"></i>
    <i v-if="showIcon" @click="save" class="el-icon-circle-check">确认</i>
  </div>
</template>

<script>
let onPicture = 'on-picture'
export default {
  props: {
    nochange: Number, // 照片是否可修改
    myHeight: Number,
    myWidth: Number,
    initImg: String,
    type: String,
    index: Number, // 用于表明 “关联家属” 时点击的是哪一张图片

    disabled: {
      type: Boolean,
      default: false
    },
    removeButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      closeShow: '',
      myCroppa: {},
      showIcon: false, // icon是否显示
      showClose: false,
      qualityVal: 2, // 图片存储时放大倍数
      initSrc: require('../../../static/images/uploadPic.jpg')
    }
  },

  mounted () {
    if (this.$props.nochange === 2) {
      // 当nochange状态为2时，图片不可修改，把×号按钮隐藏即可
      this.closeShow = 'noShow'
    }
    let div = document.getElementById('croppa')
    div.style.width = `${this.$props.myWidth}px`
    div.style.height = `${this.$props.myWidth}px`
    div = null // NOSONAR

    this.initSrc = '../../../static/images/uploadPic.jpg'
    this.qualityVal = parseInt(450 / this.$props.myWidth)

    // 延迟判断是否存在图片
    setTimeout(() => {
      if (this.myCroppa.hasImage()) {
        this.showClose = true
      }
    }, 500)
  },
  watch: {
    initImg (val) {
      if (val.indexOf('http') > -1) {
        this.initSrc = val
      }
    }
  },
  methods: {
    handleCroppaFileChoose () {
      this.showIcon = true
      this.showClose = true
    },

    handleImageRemove () {
      this.showIcon = false
      this.showClose = false
    },

    // 移除图片
    close () {
      this.myCroppa.remove()
    },

    //  保存图片
    save () {
      this.showIcon = false
      let base64Url = this.myCroppa.generateDataUrl('image/jpeg')

      let url = `upload/picture`
      this.$https
        .post(url, {
          type: 1,
          imgstr: base64Url
        })
        .then(res => {
          let obj = {
            data: res.data,
            type: this.$props.type,
            index: this.$props.index
          }

          if (res.msg === '上传成功') {
            this.$emit(onPicture, obj)
            this.$message.success('图片上传成功')
          } else {
            this.$emit(onPicture, obj)
            this.$message.error('图片上传失败，请重新上传')
            this.close()
          }
        })
        .catch(_ => {
          let obj = {
            index: this.$props.index
          }
          this.$emit(onPicture, obj)
          this.$message.error('图片上传失败，请重新上传')
          this.close()
        })
    }
  }
}
</script>

<style lang="less">
div.croppa-container.croppa--has-target {
  line-height: 0;
  text-align: left;
}

i.el-icon-circle-check,
i.el-icon-circle-close {
  font-size: 1.5rem;
  cursor: pointer;
}

i.el-icon-circle-check {
  float: right;
  color: green;
}

i.el-icon-circle-close {
  float: left;
}
.noShow {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-croppa/vue-croppa.vue